import { StyleSheet } from 'aphrodite';
export const styles = StyleSheet.create({
    page: {
        width: "100vw",
        display: "grid",
        alignContent: "center",
        justifyContent: "center"
    },

    sectionlabel: {
        marginTop: "10px",
        fontSize: "24px"
    },

    subSectionlabel: {
        marginBottom: "5px",
        fontSize: "18px"
    },

    rangeContainer: {
        display: "flex",
        flexDirection: "column",
        width: "400px",
        alignSelf: "center",
        marginTop: "10px",
        marginBottom: "10px"
    },

    searchForFieldContainer: {
        display: "grid",
        gridTemplateColumns: "auto auto",
        gridColumnGap: "20px",
        ":nth-child(1n) > input": {
            marginRight: "10px",
            padding: "5px"
        },
    },

    searchForContainer: {
        display: "grid",
        gridTemplateColumns: "min-content 20px min-content",
        gridColumnGap: "40px",
        width: "400px",
        alignSelf: "center",
        marginTop: "15px",
        marginBottom: "10px",
        alignItems: "flex-start"
    },
    
    searchInContainer: {
        display: "grid",
        gridTemplateColumns: "min-content 20px min-content",
        gridColumnGap: "40px",
        width: "400px",
        alignSelf: "center",
        marginTop: "15px",
        marginBottom: "10px",
        alignItems: "flex-start"
    },

    seperator: {
        height: "80px",
        width: "1px",
        margin: "auto",
        backgroundColor: "black"
    },

    searchInOption: {
        ":nth-child(1n) > input": {
            marginRight: "10px",
            padding: "5px"
        },
        ":nth-child(1n) > label": {
            fontSize: '16px'
        },
        whiteSpace: "nowrap",
    },

    searchBox: {
        minWidth: "350px",
        maxWidth: "400px",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "10px",
        marginBottom: "10px",
        paddingLeft: "10px",
        paddingRight: "10px",
        height: "40px"
    },

    button: {
        padding: "10px 20px 10px 20px",
        color: "white",
        backgroundColor: "rgb(0, 83, 159)",
        margin: "20px",
        borderRadius: "0px",
        fontSize: "18px",
        fontFamily: "greycliff-bold",
        textTransform: "uppercase",
        letterSpacing: "1px",
        "-webkit-font-smoothing": "auto",
        "-moz-osx-font-smoothing": "auto",
        ":hover": {
            cursor: "pointer"
        },
        width: "min-content",
        height: "40px"
    },

    range: {
        display: "grid",
        gridTemplateColumns: "min-content min-content min-content min-content",
        gridTemplateColumnGap: "20px",
        alignItems: "center",
        color: "#5a5a5aff",
        marginLeft: "0px",
        "z-index": '10'
    },

    date: {
        "white-space": "nowrap",
        padding: "5px"
    },

    dropdown: {
        position: "relative",
        display: "inline-block",
        "z-index": "1",
    },

    dropdown_content: {
        position: "absolute",
        backgroundColor: "#f1f1f1",
        "box-shadow": "0px 8px 16px 0px rgba(0,0,0,0.2)",
    },

    agenciesDropDown: {
        marginTop: "10px",
        maxWidth: '400px',
        ":nth-child(1n) > .react-dropdown-select-dropdown": {
            width: "400px",
            maxHeight: "200px"
        },
    },

    keyPhraseContainer: {
        marginTop: "10px",
    },

    keyphrase: {
        width: "400px",
        marginTop: "5px",
        padding: "5px",
        fontSize: "16px"
    },
   
    searchButton: {
        marginTop: "10px",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "100px",
        alignSelf: "center"
    }

})


// WEBPACK FOOTER //
// ./src/pages/SearchPageStyle.ts